"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ModuleContextWrapper_1 = tslib_1.__importDefault(require("./ModuleContextWrapper"));
class SubModuleRegistry {
    constructor(bootAppRegistry) {
        this.bootAppRegistry = bootAppRegistry;
    }
    registerModule(name, module) {
        this.setupModuleContext(name, module);
        this.moduleInitializationCompleted(name);
    }
    registerModuleByReference(module) {
        this.setupModuleContext(module.getName(), module);
        this.moduleInitializationCompletedByReference(module);
    }
    deregisterModule(name) {
        this.bootAppRegistry.deregisterRemoteModule(name);
    }
    deregisterModuleByReference(module) {
        this.bootAppRegistry.deregisterRemoteModule(module.getName());
    }
    setupModuleContext(_, module) {
        let remoteModuleContext = this.bootAppRegistry.registerRemoteModule(module.getName(), module);
        this.moduleContext = new ModuleContextWrapper_1.default(remoteModuleContext, module);
        this.moduleContext.setConfiguration(remoteModuleContext.getConfiguration());
        this.moduleContext.setModuleConfiguration(remoteModuleContext.getModuleConfiguration(module.getName()));
        this.moduleContext.setFramed(remoteModuleContext.isFramed());
        let patient = remoteModuleContext.getPatient();
        if (patient != null) {
            this.moduleContext.setPatient(patient);
        }
        let userContext = remoteModuleContext.getUserContext();
        if (userContext != null) {
            this.moduleContext.setUserContext(userContext);
        }
        module.setModuleContext(this.moduleContext);
    }
    setupModuleContextByReference(module) {
        this.setupModuleContext(module.getName(), module);
    }
    moduleInitializationCompleted(name) {
        this.bootAppRegistry.moduleAdded(name);
    }
    moduleInitializationCompletedByReference(module) {
        this.bootAppRegistry.moduleAdded(module.getName());
    }
    getModuleContext() {
        return this.moduleContext;
    }
    lookupModule(name) {
        return this.bootAppRegistry.lookupModule(name);
    }
}
exports.default = SubModuleRegistry;
//# sourceMappingURL=SubModuleRegistry.js.map